import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { Button, Input } from '@ipc/ipc-components';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import locale from 'date-fns/locale/en-US';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { postRepatriationsTransactionsObjectRequestActionCreator } from '../redux/actions/RepatriationsTransactionsObjectActions';
import { getAssetType } from '../../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import DATE_FORMATS from '../../../../../../common/models/constants/dateFormats';

if (locale && locale.options) {
  locale.options.weekStartsOn = 1;
}

class RepatriationsTransactionsObjectDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      description: props.row.row.comments,
      departureDateTime: props.row.row.departureDateTime !== undefined
        ? moment(props.row.row.departureDateTime).set({ second: 0 }).format(DATE_FORMATS.inputDateTime) : moment(props.row.row.departureDate).set({ second: 0 }).format(DATE_FORMATS.inputDateTime),
      outboundImpc: props.row.row.impcFrom !== undefined ? props.row.row.impcFrom : props.row.row.outboundImpc,
      inboundImpc: props.row.row.impcTo !== undefined ? props.row.row.impcTo : props.row.row.inboundImpc,
      outboundOperator: props.row.row.operatorFrom !== undefined ? props.row.row.operatorFrom : props.row.row.outboundOperator,
      inboundOperator: props.row.row.operatorTo !== undefined ? props.row.row.operatorTo : props.row.row.inboundOperator,
      plannedArrivalDateTime: props.row.row.arrivalDateTime !== undefined
        ? moment(props.row.row.arrivalDateTime).set({ second: 0 }).format(DATE_FORMATS.inputDateTime) : moment(props.row.row.arrivalDate).set({ second: 0 }).format(DATE_FORMATS.inputDateTime),
      quantity: props.row.row.quantity !== undefined ? props.row.row.quantity : props.row.row.quantityPreAdvised,
      transactionId: props.row.row.id,
      errorQuantity: '',
    };
    this.handleQuantity = this.handleQuantity.bind(this);
    this.handleComments = this.handleComments.bind(this);
    this.confirmObject = this.confirmObject.bind(this);
  }

  isFormValid = () => !(this.state.quantity === ''
    || this.state.errorQuantity === 'Quantity value can not be negative'
    || this.state.quantity === undefined)

  handleQuantity(e) {
    let error = '';
    if (parseInt(e.target.value, 0) < 0) {
      error = 'Quantity value can not be negative';
    }
    this.setState({
      quantity: e.target.value,
      errorQuantity: error,
    });
  }

  handleComments(e) {
    this.setState({
      description: e.target.value,
    });
  }

  async confirmObject() {
    await this.props.postRepatriationsTransactionsObjectRequestActionCreator(
      this.props.appContext,
      this.state.description,
      this.state.quantity,
      this.state.transactionId,
    );
    this.props.closeDialog();
    await this.props.refreshTransactions();
    this.props.refreshHistories();
  }

  render() {
    return (
      <Dialog onClose={this.props.closeDialog} aria-labelledby="simple-dialog-title" open={this.props.openDialog}>
        <DialogTitle id="simple-dialog-title">Object Transaction</DialogTitle>
        <div style={{ float: 'left' }}>
          <table className="form-table">
            <tbody>
              <tr>
                <td>
                  Outbound Operator
                </td>
                <td>
                  <Input value={this.state.outboundOperator} disabled />
                </td>
              </tr>
              <tr>
                <td>
                  Outbound IMPC
                </td>
                <td>
                  <Input value={this.state.outboundImpc} disabled />
                </td>
              </tr>
              <tr>
                <td>
                  Inbound Operator
                </td>
                <td>
                  <Input value={this.state.inboundOperator} disabled />
                </td>
              </tr>
              <tr>
                <td>
                  Inbound IMPC
                </td>
                <td>
                  <Input value={this.state.inboundImpc} disabled />
                </td>
              </tr>
              <tr>
                <td>
                  Description
                </td>
                <td>
                  <Input
                    value={this.state.description}
                    onChange={this.handleComments}
                    maxLength="40"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  Quantity
                </td>
                <td>
                  <Input
                    id="quantity"
                    type="number"
                    value={this.state.quantity}
                    onChange={this.handleQuantity}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ step: 1 }}
                  />
                  <p style={{ color: 'red' }}>{this.state.errorQuantity}</p>
                </td>
              </tr>
              <tr>
                <td>
                  Departure date & time
                </td>
                <td>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <Grid container justify="space-around">
                      <KeyboardDateTimePicker
                        autoOk
                        disableToolbar
                        variant="inline"
                        format="dd-MM-yyyy HH:mm"
                        ampm={false}
                        margin="normal"
                        id="date-picker-inline"
                        value={this.state.departureDateTime}
                        maxDate={this.state.plannedArrivalDateTime}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                        disabled
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </td>
              </tr>
              <tr>
                <td>
                  Arrival date & time
                </td>
                <td>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <Grid container justify="space-around">
                      <KeyboardDateTimePicker
                        autoOk
                        disableToolbar
                        variant="inline"
                        format="dd-MM-yyyy HH:mm"
                        ampm={false}
                        margin="normal"
                        id="date-picker-inline"
                        value={this.state.plannedArrivalDateTime}
                        minDate={this.state.departureDateTime}
                        KeyboardButtonProps={{
                          'aria-label': 'change date',
                        }}
                        disabled
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="after-box">
          <Button style={{ marginLeft: '25px', marginBottom: '10px' }} onClick={this.props.closeDialog}>Cancel</Button>
          <Button
            style={{ float: 'right', marginRight: '50px', marginBottom: '10px' }}
            onClick={this.confirmObject}
            className={`primary-button-${!this.isFormValid()}`}
            disabled={!this.isFormValid()}
          >
            Object
          </Button>
        </div>
      </Dialog>
    );
  }
}

RepatriationsTransactionsObjectDialog.propTypes = {
  row: PropTypes.objectOf(PropTypes.shape),
  appContext: PropTypes.objectOf(PropTypes.shape),
  postRepatriationsTransactionsObjectRequestActionCreator: PropTypes.func,
  openDialog: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
  refreshHistories: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    appContext: getAssetType(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  postRepatriationsTransactionsObjectRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RepatriationsTransactionsObjectDialog);
